module.exports = __webpack_public_path__ + "assets/img/2762-tn.svg";